import axios from 'axios'

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_END_POINT,
})

// axiosClient.interceptors.request.use((configs) => {
//   return {
//     ...configs,
//     headers: {
//       ...(configs || {}),
//       Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//       'Content-type': 'application/json; charset-utf-8',
//     },
//   }
// })

export default axiosClient
